<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">
        Unit-Level Alert Settings
        <v-spacer />
        <v-btn icon @click="cancel">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="mt-4">
        <p class="subtitle-1 mb-4">
          Choose how alerts should behave for this unit once a device is
          assigned
        </p>
        <div class="note-box mb-4">
          <p class="mb-2 font-weight-bold">Note:</p>
          <ul class="mb-0 pl-4" style="line-height: 1.8">
            <li class="mb-1">
              <strong>Standard Units</strong> send alerts during both access
              hours and after-hours.
            </li>
            <li class="mb-1">
              <strong>Pro Units</strong> automatically mute alerts during access
              hours.
            </li>
            <li class="mb-1">
              Alerts for Pro Units are sent
              <strong>only after access hours</strong>, even if facility-wide
              alerts are enabled.
            </li>
            <li>
              Unit-level alert behavior overrides facility-level mute settings
            </li>
          </ul>
        </div>
        <v-btn-toggle
          v-model="selectedOption"
          mandatory
          class="d-flex elevation-0"
          tile
          style="width: 100%"
        >
          <v-btn
            value="standard"
            class="flex-1 text-uppercase font-weight-bold"
            :class="{
              'success white--text': selectedOption === 'standard',
              white: selectedOption !== 'standard',
            }"
            style="
              min-height: 48px;
              letter-spacing: 0.5px;
              flex: 1 1 50%;
              border: 1px solid rgba(0, 0, 0, 0.12);
            "
          >
            Standard
          </v-btn>
          <v-btn
            value="pro"
            class="flex-1 text-uppercase font-weight-bold"
            :class="{
              'success white--text': selectedOption === 'pro',
              white: selectedOption !== 'pro',
            }"
            style="
              min-height: 48px;
              letter-spacing: 0.5px;
              flex: 1 1 50%;
              border: 1px solid rgba(0, 0, 0, 0.12);
            "
          >
            Pro: After hours only
          </v-btn>
        </v-btn-toggle>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="cancel">Cancel</v-btn>
        <v-btn color="primary" text @click="confirm">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogUnitLevelAlertSettings",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOption: "standard",
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    confirm() {
      const muteAlertsDuringDay = this.selectedOption === "pro";

      this.$emit("confirm", {
        muteAlertsDuringDay,
      });
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.v-btn-toggle {
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  display: flex;
}

.v-btn-toggle .v-btn {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
  flex: 1 1 50%;
  min-width: 0;
}

.v-btn-toggle .v-btn:last-child {
  border-right: none !important;
}

.note-box {
  background-color: #f5f5f5;
  border-left: 4px solid #4caf50;
  padding: 16px;
  border-radius: 4px;
}
</style>
